export function makeFooterHeadlinesUnTabbable() {
	var windowWidth = $(window).width();
	if(windowWidth > 1024) {
		$('footer [role="heading"] > button').each(function() {
			var thisHtml = $(this).text();
			var thisID = $(this).attr('id');
			$(this).closest('[role="heading"]').html('').append('<span class="accordion-trigger-footer" id="'+thisID+'">' + thisHtml + '</span>');
		});
	} else {
		$('footer [role="heading"] > .accordion-trigger-footer').each(function() {
			var thisHtml = $(this).text();
			var thisID = $(this).attr('id');
			var nextDivID = $(this).closest('[role="heading"]').next('.accordion-panel').attr('id');
			var nextDivLabeledBy = $(this).closest('[role="heading"]').next('.accordion-panel').attr('aria-labelledby');
			$(this).closest('[role="heading"]').html('').append('<button aria-expanded="false" class="accordion-trigger" aria-controls="'+nextDivID+'" id="'+nextDivLabeledBy+'" type="button">'+thisHtml+'<span class="icon-wrapper"><span class="meei-icon chevron-down-teal"></span></span></button>');
		});
	}
}
